import { SALES_ORDER_COLUMN_LAYOUT, SALES_ORDER_TABLE_MIN_WIDTH } from '../DataTable/columnWidths';
import { DEFAULT_COLUMN_SIZE, DEFAULT_PAGE_SIZE, LAST_CELL_GUTTER_CLASSES, TABLE_CELL_CLASSES } from '../DataTable/constants';
import { OrderSkeletonCell } from '../SalesOrderTable/OrderSkeletonCell';
import { Bar, DEFAULT_LABEL, PageShell, TableViewHeader, TableViewFooter } from './primitives';

export function OrdersPageSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <header className="flex-shrink-0 h-23 border-b border-dinnerplate-white">
        <TableViewHeader />
      </header>
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto py-4 md:py-8">
        <div className="flex flex-col gap-4 h-full min-h-0 px-6 sm:px-8 lg:px-16">
          <div className="flex flex-wrap items-center justify-between gap-4 flex-shrink-0">
            <div className="flex items-center gap-3">
              <Bar className="h-12 w-[119px]" />
              <Bar className="h-[21px] w-[21px] rounded-xs" />
            </div>
            <div className="flex items-center gap-4">
              <Bar className="h-[45px] w-[114px] rounded-input box-content border border-transparent" />
              <Bar className="h-[45px] w-[137px] rounded-input" />
            </div>
          </div>
          <div className="relative border border-dinnerplate-white rounded-input bg-off-white flex flex-col flex-1 min-h-0 overflow-hidden">
            <div className="flex-1 min-h-0 overflow-hidden">
              <table className={`w-full caption-bottom text-sm table-fixed ${LAST_CELL_GUTTER_CLASSES}`} style={{ minWidth: SALES_ORDER_TABLE_MIN_WIDTH }}>
                <colgroup>
                  {SALES_ORDER_COLUMN_LAYOUT.map((column) => (
                    <col key={column.id} style={{ width: column.width === DEFAULT_COLUMN_SIZE ? undefined : column.width }} />
                  ))}
                </colgroup>
                <thead className="bg-dinnerplate-white-light">
                  <tr className="border-b-0">
                    {SALES_ORDER_COLUMN_LAYOUT.map((column) => (
                      <th key={column.id} className={`${TABLE_CELL_CLASSES} shadow-[inset_0_-1px_0_0_theme(colors.dinnerplate-white)] text-left`}>
                        {!column.blank && <Bar className="h-[1.4em] w-20 max-w-full" />}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: DEFAULT_PAGE_SIZE }, (_, index) => (
                    <tr key={index} className="border-b border-dinnerplate-white">
                      {SALES_ORDER_COLUMN_LAYOUT.map((column) => (
                        <td key={column.id} className={`${TABLE_CELL_CLASSES} align-middle`}>
                          <OrderSkeletonCell columnId={column.id} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <footer className="flex-shrink-0 h-23 border-t border-dinnerplate-white">
        <TableViewFooter />
      </footer>
    </PageShell>
  );
}
